module.exports = __webpack_public_path__ + "img/giftvoucher.bb5e1474.svg";